/**
 * otplib-totp
 *
 * @author Gerald Yeo <contact@fusedthought.com>
 * @version: 9.0.0
 * @license: MIT
 **/
'use strict';

var _classCallCheck = require("/Users/stefan/git/ginlo/ginlo-backend/ginlo-cockpit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/stefan/git/ginlo/ginlo-backend/ginlo-cockpit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/stefan/git/ginlo/ginlo-backend/ginlo-cockpit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/stefan/git/ginlo/ginlo-backend/ginlo-cockpit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/stefan/git/ginlo/ginlo-backend/ginlo-cockpit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var otplibCore = require('./core');
var hotp = _interopDefault(require('./hotp'));
var HOTP = hotp.HOTP;
var TOTP = /*#__PURE__*/function (_HOTP) {
  _inherits(TOTP, _HOTP);
  function TOTP() {
    _classCallCheck(this, TOTP);
    return _possibleConstructorReturn(this, _getPrototypeOf(TOTP).call(this));
  }
  _createClass(TOTP, [{
    key: "generate",
    value: function generate(secret) {
      var opt = this.optionsAll;
      return otplibCore.totpToken(secret || opt.secret, opt);
    }
  }, {
    key: "check",
    value: function check(token, secret) {
      var delta = this.checkDelta(token, secret);
      return Number.isInteger(delta);
    }
  }, {
    key: "checkDelta",
    value: function checkDelta(token, secret) {
      var opt = this.optionsAll;
      return otplibCore.totpCheckWithWindow(token, secret || opt.secret, opt);
    }
  }, {
    key: "verify",
    value: function verify(opts) {
      if (typeof opts !== 'object' || opts == null) {
        return false;
      }
      return this.check(opts.token, opts.secret);
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        epoch: null,
        step: 30,
        window: 0
      };
    }
  }, {
    key: "optionsAll",
    get: function get() {
      return otplibCore.totpOptions(this._options);
    }
  }]);
  return TOTP;
}(HOTP);
TOTP.prototype.TOTP = TOTP;
var index = new TOTP();
module.exports = index;